import Button from "../../../core/Button";
import { Input } from "../../../core/Input";
import { CardContent } from "../../../shadcn/Card";
import { ClearSearchButton } from "./SharedComponents";
import { useRef, useEffect, useState } from "react";

export interface SearchNameInputProps {
  searchName: string;
  onSearchNameChange: (value: string) => void;
  onSaveSearchClick: () => void;
  onClearSearchClick: () => void;
  isSaving?: boolean;
  isDisabled?: boolean;
  autoFocusAndSelect?: boolean;
  autoFocusTrigger?: any;
}

export function SearchNameInput({
  searchName,
  onSearchNameChange,
  onSaveSearchClick,
  onClearSearchClick,
  isSaving = false,
  isDisabled = false,
  autoFocusAndSelect = false,
  autoFocusTrigger = null,
}: SearchNameInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [hasAutoSelected, setHasAutoSelected] = useState(false);

  // Focus and select text only once when auto focus is enabled and trigger changes
  useEffect(() => {
    if (autoFocusAndSelect && autoFocusTrigger && searchName && inputRef.current && !hasAutoSelected) {
      // Small delay to ensure the component has rendered
      setTimeout(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
        setHasAutoSelected(true);
      }, 100);
    }
  }, [autoFocusAndSelect, autoFocusTrigger, searchName, hasAutoSelected]);

  // Reset the auto-select flag when trigger is cleared
  useEffect(() => {
    if (!autoFocusTrigger) {
      setHasAutoSelected(false);
    }
  }, [autoFocusTrigger]);

  const handleSaveClick = () => {
    onSaveSearchClick();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && searchName.length && !isSaving && !isDisabled) {
      handleSaveClick();
    }
  };

  return (
    <>
      <CardContent className="flex flex-col items-center gap-3">
        <div className="flex flex-row items-center gap-3 w-full">
          <Input
            ref={inputRef}
            value={searchName}
            wrapperClassName="flex-1"
            onChange={(e) => onSearchNameChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter a name for this Search"
          />
          <Button
            isLoading={isSaving}
            disabled={isSaving || !searchName?.length || isDisabled}
            onClick={handleSaveClick}
          >
            Save Search
          </Button>
        </div>
      </CardContent>
      <CardContent className="flex flex-col items-center gap-3">
        <ClearSearchButton onClearSearchClick={onClearSearchClick} />
      </CardContent>
    </>
  );
}